module.exports = __webpack_public_path__ + "img/badge_color_cap-foundation.18f7bc37.svg";